import { Img } from './Img';
import { Transform } from './Transform';
import { UI } from '../../UI';

const PrintAreaAttributes = {
  fill: 'none',
  stroke: '#cc0000',
  strokeDasharray: 1,
  strokeWidth: 0.5
};

const Mapping = {
  CanvasData: (data) => {
    data = $.extend(true, {}, data);
    return {
      elemID: data.elemID,
      blank: data.selectedVariant.blank,
      panel: data.selectedPanel,
      side: data.side,
      sideName: data.sideName,
      canvasID: data.elemID + '_svg',
      aspectRatio: 1,
      baseWidth: 1000
    };
  },
  OriginalPanel: (data) => {
    return $.extend(true, {}, data.selectedPanel);
  },
  OriginalArt: (data) => {
    return data.selectedPanel.originalart || $.extend(true, {}, data.selectedPanel.art);
  },
  UpdateData: (data) => {
    data = $.extend(true, {}, data);
    return {
      blank: data.selectedVariant.blank,
      panel: data.selectedPanel
    };
  }
};

export const Canvas = class {
  constructor(_data) {
    this.$El = $(`#${_data.elemID}`);
    this.$Canvas = null;
    this.$Toolbar = null;
    this.$Base = null;
    this.$Blank = null;
    this.$Art = null;
    this.$ArtTransformer = null;
    this.$PrintArea = null;
    this.$originalArt = Mapping.OriginalArt(_data); //_data.originalPanel;
    this.$canvasData = Mapping.CanvasData(_data);
    this.placeholderEl = $(`<div class="d-studio-link-placeholder"><i class="fal fa-3x fa-image"></i>
                              <p>${
                                $lang.ministu[
                                  _data.side === 4 ? 'SelectTrim' : _data.side === 5 ? 'SelectHangtag' : 'SelectArtworkOrTrim'
                                ]
                              }</p>
                            </div>`);
    this.loaderEl = $(`<div class="d-studio-loader-wraper"><i></i></div>`);
    this.onAdd = _data.onAdd;
    this.onChange = _data.onChange;
    this.loading = false;
    this.NEW = false;
    this.REMOVED = false;
  }

  create() {
    const _self = this;

    const template = require('./tmpl/base.hbs');
    $(`#${_self.$canvasData.elemID}`).html(template(_self.$canvasData));
    setTimeout(() => _self._placeBase(), 30);

    window.addEventListener('resize', _self._debounce(_self._redraw, _self, 150));
  }

  redrawArt(_data) {
    const _self = this;
    _self.$canvasData = {
      ..._self.$canvasData,
      ...Mapping.UpdateData(_data)
    };
    _self.$originalArt = Mapping.OriginalArt(_data);
    _self._redraw(_self);
  }

  redrawBlank(_data) {
    const _self = this;
    _self.$canvasData = {
      ..._self.$canvasData,
      ...Mapping.UpdateData(_data)
    };
    _self._loader('show');
    _self.$Blank.update(_self.$canvasData.blank.uri).then(() => {
      _self._loader('hide');
    });
  }

  update(_data) {
    const _self = this;

    _self._loader('show');
    $('button', _self.$Toolbar).prop({ disabled: true });

    _self.$canvasData = {
      ..._self.$canvasData,
      ...Mapping.UpdateData(_data)
    };
    _self.$originalArt = Mapping.OriginalArt(_data);

    _self.$Blank.update(_self.$canvasData.blank.uri).then(() => {
      if (_self.$Blank.loadingFail) {
        _self._errorLoadingHandler({ mess: 'Blank Image loading fail!' });
      }

      if (this.$Art && this.$ArtTransformer) {
        this.$ArtTransformer.destroy();
        this.$Art.remove();
        this.$ArtTransformer = null;
        this.$Art = null;
      }

      _self.$PrintArea = _self._printArea();

      if (!_self.$PrintArea) {
        return _self._errorMessage({ mess: 'Print Area not defined!' });
      }

      _self._createArt();
    });
  }

  addArt(data) {
    if (!data?.art?.uri) return;

    const _self = this;

    _self._loader('show');

    _self.$canvasData.panel = { ...data };

    _self.$Art = new Img(_self.$canvasData.panel.art.uri, _self.$Base);
    _self.$Art.get().then(() => {
      if (_self.$Art.loadingFail) {
        _self._errorLoadingHandler();
      }

      _self.NEW = true;

      _self.$originalArt = $.extend(true, {}, _self.$canvasData.panel.art);

      _self.placeholderEl.remove();

      _self._placeArt();

      _self._onChangeHandler();
    });
  }

  removeArt() {
    const _self = this;
    bootbox.dialog({
      title: 'Delete',
      message: `<h5 class="my-2">${$Lang.alert.WantDelete}?</h5>`,
      className: 'modal-danger deletemessage-dialog-modal',
      buttons: {
        Ok: {
          label: $lang.btn.delete,
          className: 'btn btn-danger',
          callback: () => _self._removeArt()
        },
        cancel: { label: $lang.btn.cancel, className: 'btn btn-link' }
      }
    });
  }

  isChanged() {
    return this.NEW || this.REMOVED || this._isArtMoved();
  }

  getPNG() {
    const _self = this;

    return new Promise((resolve, reject) => {
      const id = _self.$canvasData.canvasID;

      _self._transformerGrid('hide');
      let svgString = new XMLSerializer().serializeToString(document.getElementById(id));

      let canvas = document.createElement('canvas');
      canvas.width = _self.$Blank.Width;
      canvas.height = _self.$Blank.Height;
      let ctx = canvas.getContext('2d');
      let DOMURL = self.URL || self.webkitURL || self;
      let svg = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
      let url = DOMURL.createObjectURL(svg);
      let img = new Image();
      img.src = url;
      _self._transformerGrid('show');
      img.onload = function () {
        ctx.drawImage(img, 0, 0);
        let png = canvas.toDataURL('image/png');
        DOMURL.revokeObjectURL(png);
        resolve(png);
      };
      img.onerror = (e) => {
        return reject('Error creating image');
      };
    });
  }

  _onChangeHandler() {
    let art = this._outputArt();
    if (art) {
      art.moved = this.isChanged();
    }

    this.$canvasData.panel.art = art;

    this._toolbarUpdate();

    if (this.onChange) {
      this.onChange(art);
    }
  }

  _placeBase() {
    const _self = this;

    _self.$Canvas = $(`#${_self.$canvasData.canvasID}`);
    _self.$Toolbar = $(`#${_self.$canvasData.canvasID}_buttons`);

    _self._loader('show');

    _self.$Base = Snap(`#${_self.$canvasData.canvasID}`);

    _self.$Blank = new Img(_self.$canvasData.blank.uri, _self.$Base);
    _self.$Blank.get().then(() => {
      // Must be first
      _self.$canvasData.aspectRatio = _self.$Blank.AspectRatio;

      if (_self.$Blank.loadingFail) {
        _self._errorLoadingHandler({ mess: 'Blank Image loading fail!' });
      }

      _self.$Blank.place();
      _self.$Base.animate({ height: _self.$Blank.NaturalHeight * _self.$Blank.AspectRatio }, 250, mina.linear, () => {
        _self.$canvasData.baseWidth = _self.$Blank.NaturalWidth;

        _self.$PrintArea = _self._printArea();

        if (!_self.$PrintArea) {
          return _self._errorMessage({ mess: 'Print Area not defined!' });
        }

        _self._toolbarInit();

        _self._createArt();
      });
    });
  }

  _redraw(_self) {
    _self._loader('show');
    _self.$Blank.redraw();
    _self.$canvasData.aspectRatio = _self.$Blank.AspectRatio;
    _self.$Base.attr({ height: _self.$Blank.NaturalHeight * _self.$Blank.AspectRatio });
    _self.$canvasData.baseWidth = _self.$Blank.NaturalWidth;
    _self.$PrintArea = _self._printArea();
    _self._redrawArt();
  }

  /*
   ** TOOLBAR
   */
  _toolbarInit() {
    const _self = this;

    _self.$Toolbar
      .off()
      .on('click', '.js-action-ds-gridof', () => _self._transformerGrid())
      .on('click', '.js-action-ds-centerV', () => _self._transformerCenter('V'))
      .on('click', '.js-action-ds-centerH', () => _self._transformerCenter('H'))
      .on('click', '.js-action-ds-reset', () => _self._resetArt());

    $('[data-toggle="tooltip"]', _self.$Toolbar).tooltip();
  }

  _toolbarUpdate() {
    const _self = this;
    const transformer = _self.$ArtTransformer;
    const isArtMoved = _self._isArtMoved();

    $('[data-toggle="tooltip"]', _self.$Toolbar).tooltip('dispose');

    $('button.js-action-ds-reset', _self.$Toolbar).prop({ disabled: !isArtMoved || !transformer });
    $('button:not(.js-action-ds-reset)', _self.$Toolbar).prop({ disabled: !transformer });

    $('[data-toggle="tooltip"]', _self.$Toolbar).tooltip();
  }

  /*
   ** ART
   */
  _createArt() {
    let _self = this;

    this.placeholderEl.remove();

    if (!_self.$canvasData.panel?.art?.uri) {
      _self._placeholder();
      _self._toolbarUpdate();
      return;
    }

    _self.$Art = new Img(_self.$canvasData.panel.art.uri, _self.$Base);
    _self.$Art.get().then(() => {
      if (_self.$Art.loadingFail) {
        _self._errorLoadingHandler();
      }
      _self._placeArt();
    });
  }

  _placeArt() {
    let _self = this;

    if (!_self.$Art) {
      return;
    }

    const artParams = _self._inputArt();
    _self.$Art.place(artParams);

    const transformParams = {
      handleRotate: false, // Rotation Handle options
      handleRemove: true, // Enable removing artwork from any side
      mask: _self.$PrintArea ? _self.$PrintArea : false,
      boundary: _self.$PrintArea ? _self.$PrintArea : false,
      onChange: (data) => _self._onChangeHandler(data),
      remove: () => _self.removeArt()
    };

    if (_self.$canvasData?.panel?.frame?.frameType > 0 && _self.$canvasData?.side < 4) {
      transformParams.handles = { scale: [] };
    }

    _self.$ArtTransformer = new Transform(_self.$Art.El, transformParams);

    _self.$ArtTransformer.plug();

    _self._toolbarUpdate();

    UI.unblock('body'); // To unblock page after first init
    _self._loader('hide');
  }

  _resetArt() {
    this.$canvasData.panel.art = $.extend(true, {}, this.$originalArt);
    if (this.$ArtTransformer) this.$ArtTransformer.show();
    this._redrawArt();
    this._onChangeHandler();
  }

  _destroyArt() {
    this.$ArtTransformer.destroy();
    this.$Art.remove();
    this.$ArtTransformer = null;
    this.$Art = null;
    this.$canvasData.panel.art = null;
  }

  _removeArt() {
    if (this.NEW) {
      this.NEW = false;
    } else {
      this.REMOVED = true;
    }
    this._destroyArt();
    this._placeholder();
    this._onChangeHandler();
  }

  _redrawArt() {
    if (this.$Art && this.$ArtTransformer) {
      this.$ArtTransformer.destroy();
      this.$Art.remove();
      this._placeArt();
    } else {
      this.placeholderEl.remove();
      this._placeholder();
    }
  }

  _inputArt() {
    const params = this.$canvasData.panel.art;
    const area = this.$canvasData.panel.area;
    const ratio = this.$canvasData.aspectRatio;

    let placeParams = {
      x: (params.x + area.x) * ratio,
      y: (params.y + area.y) * ratio,
      w: params.w,
      h: params.h,
      a: params.a,
      ratio: ratio
    };

    return placeParams;
  }

  _outputArt() {
    let art = this.$Art && this.$ArtTransformer ? this.$ArtTransformer.getPosition().art : null;
    if (art) {
      const ratio = this.$canvasData.aspectRatio;
      const area = this.$canvasData.panel.area;
      art = {
        ...this.$canvasData.panel.art,
        ...{
          x: Math.round(art.x / ratio - area.x),
          y: Math.round(art.y / ratio - area.y),
          w: Math.round(art.w / ratio),
          h: Math.round(art.h / ratio),
          a: this._round(art.a)
        }
      };
    }
    return art;
  }

  _isArtChanged() {
    const art = this._outputArt();
    const oart = this.$originalArt;

    return !this._deepEqual(art, oart);
  }

  _isArtMoved() {
    const thisArt = this._outputArt();
    const originalArt = this.$originalArt;

    if ((thisArt && $.isEmptyObject(originalArt)) || (!thisArt && !$.isEmptyObject(originalArt))) {
      return true;
    } else if (!thisArt && $.isEmptyObject(originalArt)) {
      return false;
    }

    /*let attrs = this.$ArtTransformer.getPosition().attributes;

    return attrs.scale.x != 1
           || attrs.scale.y != 1
           || attrs.translate.x != 0
           || attrs.translate.y != 0
           || Math.abs(originalArt.a - thisArt.a) > 0.5;*/

    return (
      Math.abs(originalArt.w - thisArt.w) > 2 ||
      Math.abs(originalArt.h - thisArt.h) > 2 ||
      Math.abs(originalArt.x - thisArt.x) > 2 ||
      Math.abs(originalArt.y - thisArt.y) > 2 ||
      Math.abs(originalArt.a - thisArt.a) > 0.5
    );
  }

  _placeholder() {
    const _self = this;

    const area = _self.$canvasData.panel.area;
    const ratio = _self.$canvasData.aspectRatio;

    if (!area) {
      _self._loader('hide');
      return;
    }

    _self.$Canvas.after(
      _self.placeholderEl
        .css({ left: area.x * ratio, top: area.y * ratio, width: area.w * ratio, height: area.h * ratio })
        .toggleClass('placeholder-sm', area.w * ratio < 90)
        .on('click', () => {
          _self.onAdd(_self.$canvasData);
        })
    );

    _self._loader('hide');
  }

  _printArea() {
    let _self = this;
    const ratio = _self.$canvasData.aspectRatio;
    const area = _self.$canvasData.panel?.area;

    if (_self.$PrintArea) {
      _self.$PrintArea.remove();
    }

    if (!area) {
      return false;
    }
    return _self.$Base.rect(area.x * ratio, area.y * ratio, area.w * ratio, area.h * ratio).attr(PrintAreaAttributes);
  }

  /*
   ** TRANSFORMER
   */
  _transformerGrid(action = '') {
    const _self = this;
    const $transformer = _self.$ArtTransformer;
    if (!$transformer) {
      return;
    }
    const isHidden = action == 'hide' ? false : action == 'show' ? true : $transformer.isHidden();
    if (isHidden) {
      $transformer.show();
    } else {
      $transformer.hide();
    }
    _self.$PrintArea.attr({ opacity: isHidden ? 1 : 0 });
  }

  _transformerCenter(axis) {
    const _self = this;
    const $transformer = _self.$ArtTransformer;
    if (!$transformer) {
      return;
    }
    $transformer.centralize(axis);
  }

  _errorLoadingHandler(e) {
    this._errorMessage(e);
  }

  _errorMessage({ mess = 'Image loading error!' } = {}) {
    const alert = $(`<div class="alert alert-danger">
                      <div class="alert-text"><i class="fal fa-exclamation-circle fa-lg mr-2"></i> ${mess}</div>
                      <div class="alert-close"><button type="button" class="close" data-dismiss="alert"><i class="fal fa-times"></i></button></div>
                    </div>`);
    this.$Canvas.parent().find('.d-studio-alert-box').append(alert);
    //setTimeout(()=>alert.fadeOut(), 5000);
  }

  _clearMessage() {
    this.$Canvas.parent().find('.d-studio-alert-box').empty();
  }

  _loader(action = '') {
    if (action === 'show') {
      this._clearMessage();
      //$('#page').append( this.loaderEl )
      this.$Canvas.after(this.loaderEl);
      this.loading = true;
      return;
    }
    if (action === 'hide') {
      this.loaderEl.remove();
      this.loading = false;
      return;
    }
    if (this.loading) {
      this.loaderEl.remove();
      this.loading = false;
    } else {
      this.$Canvas.after(this.loaderEl);
      this.loading = true;
    }
    return this.loading;
  }

  _debounce(func, arg, time = 100) {
    let timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => func(arg), time, event);
    };
  }

  _deepEqual(object1, object2) {
    if (object1 === null && object2 === null) {
      return true;
    }

    if (object1 === null || object2 === null) {
      return false;
    }

    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = this._isObject(val1) && this._isObject(val2);
      if ((areObjects && !this._deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
        return false;
      }
    }

    return true;
  }

  _isObject(object) {
    return object != null && typeof object === 'object';
  }

  _round(num) {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  }
};
